










































import {
    Component,
    ComponentStyle,
    ComponentStyleDefinition,
    Answer,
    Prop,
} from "@zoovu/runner-browser-api";
import SimpleBar from "simplebar-vue";
import DropDownQuestionView from './drop-down-question.vue';

@Component({components: {SimpleBar}})
export default class FilterDropDownQuestionView extends DropDownQuestionView {

    @Prop()
    showDisabledAnswers: boolean;

    @Prop()
    hideOptionLabels: boolean;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    dropdownOpened: boolean = true;

    shouldBeShown(answer: Answer): boolean {
        return answer && (!answer.disabled || this.showDisabledAnswers);
    }

    showImage(answer: Answer): boolean {
        return answer.images != null && answer.images[0] != null;
    }

    get doesSomeAnswerHaveImage(): boolean {
        return this.question.answers.some(answer => answer.images && answer.images.length > 0);
    }

    get componentStateClasses() {
        return {
            'has-image': this.doesSomeAnswerHaveImage,
            'no-labels': this.hideOptionLabels,
        }
    }
}
